import {
    AfterViewInit,
    Component,
    ComponentRef,
    DestroyRef,
    EnvironmentInjector,
    EventEmitter,
    InjectionToken,
    Injector,
    Input,
    OnChanges,
    OnDestroy,
    Output,
    Provider,
    Type,
    ViewContainerRef,
    inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { DefaultQuickbetInfoPanelComponent } from './default-quickbet-info-panel.component';

export const QuickbetInfoPanelComponentToken = new InjectionToken<Type<any>>('QuickbetInfoPanelComponentToken');

export function provideQuickbetInfoPanelComponent(cmp: typeof DefaultQuickbetInfoPanelComponent): Provider {
    return {
        provide: QuickbetInfoPanelComponentToken,
        useValue: cmp,
    } as Provider;
}

@Component({
    selector: 'quickbet-info-panel',
    template: ``,
    standalone: true,
})
export class QuickbetInfoPanelComponent implements OnChanges, AfterViewInit, OnDestroy {
    @Output() readonly notificationsPanelClickFn: EventEmitter<void> = new EventEmitter();
    @Output() readonly externalLinksFn: EventEmitter<boolean> = new EventEmitter();
    @Input() qdIsShown?: boolean;

    private injector = inject(Injector);
    private envInjector = inject(EnvironmentInjector);
    private destroyRef = inject(DestroyRef);
    private vcr = inject(ViewContainerRef);
    private cmpToken = inject(QuickbetInfoPanelComponentToken);

    private cmpRef?: ComponentRef<any>;

    ngOnChanges() {
        this.syncInputs();
    }

    ngAfterViewInit() {
        if (!this.cmpToken) {
            throw new Error('Please provide a quickbet-info-panel component!');
        }

        this.cmpRef = this.vcr.createComponent(this.cmpToken, {
            injector: this.injector,
            environmentInjector: this.envInjector,
        });

        this.syncInputs();

        if (this.cmpRef) {
            this.cmpRef.instance.notificationsPanelClickFn.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((x: any) => {
                this.notificationsPanelClickFn.emit(x);
            });

            this.cmpRef.instance.externalLinksFn.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((x: any) => {
                this.externalLinksFn.emit(x);
            });
        }
    }

    private syncInputs() {
        if (this.cmpRef) {
            this.cmpRef.setInput('qdIsShown', this.qdIsShown);
        }
    }

    ngOnDestroy(): void {
        this.cmpRef && this.cmpRef.destroy();
    }
}
